import { Link } from 'react-router-dom';
import history from '../../helpers/history';
import Page from '../../layout/components/Page';
import LocationBadge from '../Common/LocationBadge';

const ProviderJobs = () => {
  return (
    <Page title='Jobs' icon='bi-clipboard'>
      <div className='row'>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div key={item} className='col-md-6 mb-4 mb-xl-6' onClick={() => history.push(`/service-providers/${item}`)}>
            <div className='card'>
              <div className='card-body-slim pb-0'>
                <div className='d-flex align-items-center mb-5'>
                  <div className='d-flex align-items-center flex-grow-1'>
                    <div className='d-flex flex-column'>
                      <Link to={`/service-providers/${item}`} className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                        Investor John
                      </Link>

                      <LocationBadge location='Lagos, Nigeria' />
                    </div>
                  </div>
                </div>

                <div className='mb-5'>
                  <p className='text-gray-800 fw-normal mb-5'>Outlines keep you honest. They stop you from indulging in poorly thought-out metaphors about driving and keep you focused on the overall structure of your post</p>

                  <div className='d-flex align-items-center mb-5'>
                    <span className='btn btn-sm btn-light-success btn-active-light-success px-4 py-2 me-4'>Lawyers</span>

                    <span className='btn btn-sm btn-light-warning  btn-active-light-danger px-4 py-2'>$500</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
};

export default ProviderJobs;
